import { Component } from "@angular/core";
import { NavController, NavParams, LoadingController, ModalController, AlertController } from "ionic-angular";
import { SummaryServiceProvider } from "../../../providers/wh/summary-service";
import { WaybillOrderServiceProvider } from "../../../providers/qdb/qdb-service";
import { DatePipe } from "@angular/common";
import { SearchParcel } from './../../qdb/search-parcel/index';

@Component({
  selector: "create-dhl-shipment-page",
  templateUrl: "index.html",
  providers: [SummaryServiceProvider, WaybillOrderServiceProvider]
})
export class CreateDHLShipment {
  header_data: any;

  objectKeys = Object.keys;

  awbNumber: any = "";
  awb: any = "";
  cod: any = "";
  siteId: any = "";
  pieceIds: any = [];
  shipmentExists: boolean;
  shipmentNotExists: boolean;

  constructor(
    public navCtrl: NavController,
    public modalCtrl: ModalController,
    public waybillOrderService: WaybillOrderServiceProvider,
    public datepipe: DatePipe,
    private alertCtrl: AlertController,
    public navParams: NavParams,
    public summaryService: SummaryServiceProvider,
    public loadingCtrl: LoadingController
  ) {
    this.header_data = {
      ismenu: true,
      ishome: false,
      title: "Create DHL Shipment",
      parentReloadData: d => {
        // this.load_cp_data(true)
      }
    };

    // this.searchWaybill();
  }

  searchWaybill() {
    this.shipmentExists = false;
    this.shipmentNotExists = false;
    this.summaryService.getRequestInfo(`/api/v0.2/backoffice/shipment/query/dhl?awb=${this.awbNumber}`)
      .then((res: any) => {
        // {"code":1001,"msg":"Success","data":{"awb":"638119001","pieceIds":["JD011100003638119001","JD011100003638119001"],"cod":""},"is_end":0}
        if (res.code == 1001) {
          this.shipmentExists = true;
          let responseData = res.data;
          this.awb = responseData.awb;
          this.pieceIds = responseData.pieceIds;
          this.cod = responseData.cod;
        } else {
          this.shipmentNotExists = true;
        }
      });
  }

  createShipment() {
    console.log("Create Shipment");
    let payload = {
      awb: this.awb,
      pieces: this.pieceIds,
      stationId: this.siteId
    };
    console.log("Payload", payload);
    // this.navCtrl.setRoot(SearchParcel, { awb: this.awb });
    this.summaryService.createManualDhlShipment(payload)
      .then((res: any) => {
        console.log("Res", res);
        if (res.code == 1001) {
          console.log("Success");
          this.navCtrl.setRoot(SearchParcel, { awb: this.awb });
        } else {
          console.log("Failed");
        }
      });
  }


  confirmationAlert() {
    let message = `Are you sure you want to create shipment #${this.awb} with piece(s) ${this.pieceIds} for Site Id ${this.siteId}`;
    let alert = this.alertCtrl.create({
      title: "Confirm",
      message: `${message}`,
      buttons: [
        {
          text: "No",
          role: "cancel",
          handler: () => { }
        },
        {
          text: "Yes",
          handler: () => { this.createShipment() }
        }
      ]
    });
    alert.present();

  }
}



// WEBPACK FOOTER //
// ./src/pages/backoffice/create-dhl-shipment/index.ts